module.exports = __webpack_public_path__ + "static/springio-c1df2eaa300245348d1958fd94ebc819.png";